import React from 'react'
import styled from '@emotion/styled'

const Wrapper = styled.div`
  margin: 0 auto 2em;
  max-width: ${props => props.theme.sizes.maxWidthCentered};
  span {
    margin: 0 0.5rem;
  }
`

const Date = styled.p`
  display: inline-block;
`

const ReadingTime = styled.p`
  display: inline-block;
`

const PostDetails = props => {
  return (
    <Wrapper>
      <Date>📅 {props.date}</Date>
      <span>•</span>
      <ReadingTime>{`⏱️ ${props.timeToRead} min read `}</ReadingTime>
      {/* <span>•</span>
      <i className="fab fa-facebook" style={{ color: '#3b5998'}}></i>&nbsp;&nbsp;&nbsp;&nbsp;
      <i className="fab fa-twitter" style={{ color: '#1da1f2'}}></i>&nbsp;&nbsp;&nbsp;&nbsp;
      <i className="fab fa-linkedin" style={{ color: '#0072b1'}}></i> */}
    </Wrapper>
  )
}

export default PostDetails
